import { Card, Col, Row, Skeleton, Space } from "antd";

export const LoadingForm = () => {
  return (
    <>
      <Space
        style={{
          width: '100%',
          justifyContent: 'space-between',
          padding: '10px',
          marginBottom: '10px',
        }}
      >
        <Skeleton.Button active />
        <Space>
          <Skeleton.Button active />
          <Skeleton.Button active />
        </Space>
      </Space>
      <Card>
        <div className="title-card">
          <Skeleton.Button active />
        </div>
        <Row gutter={[16, 16]}>
          {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15].map((item) => (
            <Col xs={24} sm={12} md={8} lg={8} key={item}>
              <Skeleton.Input active block />
            </Col>
          ))}
        </Row>
        <Row gutter={[16, 16]}>
          {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((item) => (
            <Col xs={24} sm={12} md={8} lg={8} key={item}>
              <div
                className="skeleton-desc"
                style={{ marginTop: '20px', height: '100px' }}
              >
                <Skeleton.Input active block />
              </div>
            </Col>
          ))}
        </Row>
        <Skeleton.Button active style={{ marginTop: '20px' }} />
      </Card>
    </>
  );
};
